import axios from 'axios'
const instance = axios.create({
    // baseURL: 'http://localhost:3000',
    baseURL: `${process.env.REACT_APP_API_URL}`,
    headers: {
        'Content-Type': 'application/json'
    }
})

const formatAuthorization = idToken => idToken + '.' + btoa(JSON.stringify({ 'id': process.env.REACT_APP_ID }))

export default {
    getLists: (idToken, params) => new Promise((resolve, reject) => {
        instance.post(
            '/vallourec-services/manage-list',
            params,
            {
                headers: {
                    Authorization: formatAuthorization(idToken)
                }
            }
        ).then(response => {
            if (response.status === 200) {
                resolve(response.data)
            }
            else {
                reject(new Error('Couldn\'t retrieve data'))
            }
        })
            .catch(error => {
                reject(error.response && error.response.data ? error.response.data : error)
            })
    }),

    getSpecificLists: (idToken, params) => new Promise((resolve, reject) => {
        instance.post(
            '/vallourec-services/specific-list',
            params,
            {
                headers: {
                    Authorization: formatAuthorization(idToken)
                }

            }
        ).then(response => {
            if (response.status === 200) {
                resolve(response.data)
            }
            else {
                reject(new Error('Couldn\'t retrieve data'))
            }
        })
            .catch(error => {
                reject(error.response && error.response.data ? error.response.data : error)
            })
    }),

    getInfoList: (idToken, params) => new Promise((resolve, reject) => {
        instance.post(
            '/vallourec-services/specific-list',
            params,
            {
                headers: {
                    Authorization: formatAuthorization(idToken)
                }
            }
        ).then(response => {
            if (response.status === 200) {
                resolve(response.data)
            }
            else {
                reject(new Error('Couldn\'t retrieve data'))
            }
        })
            .catch(error => {
                reject(error.response && error.response.data ? error.response.data : error)
            })
    }),

    uploadManualData: (idToken, params) => new Promise((resolve, reject) => {
        instance.post(
            '/vallourec-services/upload-manual-data',
            params,
            {
                headers: {
                    Authorization: formatAuthorization(idToken)
                }
            }
        ).then(response => {
            if (response.status === 200) {
                resolve(response.data)
            }
            else {
                reject(new Error('Couldn\'t retrieve data'))
            }
        })
            .catch(error => {
                reject(error.response && error.response.data ? error.response.data : error)
            })
    }),
}